import { themeWorkspace } from "./theme-node.js";
import { server } from "../../../src/config/settings-network.mjs";

import * as Blockly from "blockly/core";

import { init as initText } from "../toolbox/texts/toolbox.js";
import { init as initDisplay } from "../toolbox/display/toolbox.js";
import { init as initQuestion } from "../toolbox/questions/toolbox.js";
import { init as initFeedback } from "../toolbox/feedback/toolbox.js";
import { init as initExperimental } from "../toolbox/experimental/toolbox.js";
import { init as initMedia } from "../toolbox/media/toolbox.js";
import { init as initLists } from "../toolbox/lists/toolbox.js";
import { init as initAlgebra } from "./math/algebra/toolbox.js";
import { init as initAnalysis } from "./math/analysis/toolbox.js";
import { init as initGeometry } from "./math/geometry/toolbox.js";
import { init as initMatrix } from "./math/matrix/toolbox.js";
import { init as initStats } from "./math/stats/toolbox.js";

//import { eledaFrenchCategory } from "./lang/french/toolbox.js";

import { init as initLogic } from "../toolbox/logic/toolbox.js";
import { init as initLoops } from "../toolbox/loops/toolbox.js";
/*
export const eledaVarCategoryJson = {
  kind: "category",
  name_universal: "var",
  name: "%{BKY_CATVARIABLES}",
  colour: themeWorkspace.categoryStyles.variable_category.colour,
  imageName: "/toolbox-imgs/database-solid.svg",
  id: "20",
  custom: "VARIABLE",
};
*/

export function initToolbox() {
  let eledaTextsCategoryJson = initText();
  let eledaDisplayCategoryJson = initDisplay();
  let eledaQuestionCategoryJson = initQuestion();
  let eledaFeedbackCategoryJson = initFeedback();
  let eledaExperimentalCategoryJson = initExperimental();
  let eledaMediaCategoryJSON = initMedia();
  let eledaListsCategoryJson = initLists();
  let eledaAlgebraCategoryJson = initAlgebra();
  let eledaAnalysisCategoryJson = initAnalysis();
  let eledaGeometryCategoryJson = initGeometry();
  let eledaMatrixCategoryJson = initMatrix();
  let eledaStatsCategoryJson = initStats();
  let eledaLogicCategoryJson = initLogic();
  let eledaLoopsCategoryJson = initLoops();

  const eledaVarEledaCategoryJson = {
    kind: "category",
    name_universal: "var",
    name: "%{BKY_CATVARIABLES}",
    colour: themeWorkspace.categoryStyles.variable_category.colour,
    imageName: "/toolbox-imgs/database-solid.svg",
    id: "20",
    custom: "VARIABLE_ELEDA",
  };

  const eledaFunctionsCategoryJson = {
    kind: "category",
    name_universal: "functions",
    name: "%{BKY_CATFUNCTIONS}",
    colour: themeWorkspace.categoryStyles.procedure_category.colour,
    imageName: "/toolbox-imgs/cog-solid.svg",
    id: "33",
    custom: "PROCEDURE",
  };

  const eledaMathCategoryJson = {
    kind: "category",
    name_universal: "math",
    name: "%{BKY_CATMATH}",
    expanded: false,
    colour: themeWorkspace.categoryStyles.math_category.colour,
    cssConfig: {
      container: "math",
    },
    imageName: "/toolbox-imgs/square-root-alt-solid.svg",
    id: "100",
    contents: [
      eledaAlgebraCategoryJson,
      eledaAnalysisCategoryJson,
      eledaGeometryCategoryJson,
      eledaMatrixCategoryJson,
      eledaStatsCategoryJson,
    ],
  };

  const eledaToolboxJson = {
    kind: "categoryToolbox",
    contents: [
      eledaDisplayCategoryJson,
      eledaQuestionCategoryJson,
      eledaFeedbackCategoryJson,
      {
        kind: "sep",
      },
      eledaMediaCategoryJSON,
      eledaTextsCategoryJson,
      eledaListsCategoryJson,
      eledaMathCategoryJson,
      {
        kind: "sep",
      },
      // eledaVarCategoryJson,
      eledaVarEledaCategoryJson,
      eledaLogicCategoryJson,
      eledaLoopsCategoryJson,
      eledaFunctionsCategoryJson,
    ],
  };

  if (server != "production") {
    eledaToolboxJson.contents.unshift(eledaExperimentalCategoryJson);
  }

  return eledaToolboxJson;
}
